import { Alert } from "@mui/material";

function SuccessAndErrorMessage({ error, success }) {
  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  if (success) {
    return <Alert severity="success">{success}</Alert>;
  }

  return null;
}

export default SuccessAndErrorMessage;
